import type { EmployeeDto } from "Infrastructure/Api/Api";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { EmployeeAutocomplete as EmployeeAutocompleteInput } from "Components/Shared/Inputs/EmployeeAutocomplete";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  employees: Array<EmployeeDto>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  name: FieldPath<FormType>;
  label: string;
  disabled?: boolean;
  helperText?: string;
  emptyValueText?: string;
};

export const EmployeeAutocomplete = <T extends object, V extends object>({
  employees,
  control,
  name,
  label,
  disabled = false,
  helperText,
  emptyValueText,
}: Props<T, V>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, fieldState: { error } }) => (
      <EmployeeAutocompleteInput
        employees={employees}
        name={name}
        label={label}
        disabled={disabled}
        onChange={onChange}
        value={value}
        errorMessage={error?.message}
        helperText={helperText}
        emptyValueText={emptyValueText}
      />
    )}
  />
);
